import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../authentication/auth.guard';
import { CompanyGuard } from '../companies/company.guard';
import { DivisionGraphsComponent } from './division-graphs/division-graphs.component';
import { EmployeeGraphsComponent } from './employee-graphs/employee-graphs.component';
import { FinancialHomeComponent } from './financial-home/financial-home.component';
import { OverheadGraphsComponent } from './overhead-graphs/overhead-graphs.component';
import { ProjectGraphsComponent } from './project-graphs/project-graphs.component';
import { ResearchDevelopmentOverviewComponent } from './research-development-overview/research-development-overview.component';
import { TurnoverGraphComponent } from './turnover-graph/turnover-graph.component';
import { JiraProjectsOverviewComponent } from './jira-projects-overview/jira-projects-overview.component';
import { BudgetOverviewComponent } from './budget-overview/budget-overview.component';
import { ContractsOverviewComponent } from './contracts-overview/contracts-overview.component';
import { ProjectBudgetsOverviewComponent } from './project-budgets-overview/project-budgets-overview.component';

export const routes: Routes = [
    {
        path: '',
        component: FinancialHomeComponent,
        children: [
            { path: '', redirectTo: 'overhead', pathMatch: 'full' },
            { path: 'overhead', component: OverheadGraphsComponent, canActivate: [AuthGuard, CompanyGuard] },
            { path: 'employees', component: EmployeeGraphsComponent, canActivate: [AuthGuard, CompanyGuard] },
            { path: 'projects', component: ProjectGraphsComponent, canActivate: [AuthGuard, CompanyGuard] },
            { path: 'research-development', component: ResearchDevelopmentOverviewComponent, canActivate: [AuthGuard, CompanyGuard] },
            { path: 'jira-projects', component: JiraProjectsOverviewComponent, canActivate: [AuthGuard, CompanyGuard] },
            { path: 'turnover', component: TurnoverGraphComponent, canActivate: [AuthGuard, CompanyGuard] },
            { path: 'budgets', component: BudgetOverviewComponent, canActivate: [AuthGuard, CompanyGuard] },
            { path: 'contracts', component: ContractsOverviewComponent, canActivate: [AuthGuard, CompanyGuard] },
            { path: 'project-budgets', component: ProjectBudgetsOverviewComponent, canActivate: [AuthGuard, CompanyGuard] },
            { path: 'targets', component: DivisionGraphsComponent, canActivate: [AuthGuard, CompanyGuard] },
            { path: 'divisions', redirectTo: 'targets', pathMatch: 'full' },
        ],
    },
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
